import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import HeritageMark from "@/components/common/HeritageMark";

const EMAIL = "info@heracq.com";

export default function CareFooter({ site }) {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(site.address.mapsQuery)}`;

  return (
    <footer
      data-testid={`care-footer-${site.key}`}
      className="bg-[#1A2621] text-[#FDFBF7] pt-24 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3">
              <HeritageMark size={44} bg="#FDFBF7" stroke="#1A2621" accent="#C86A51" />
              <div className="font-serif-display">
                <div className="text-2xl md:text-3xl leading-none">Heritage</div>
                <div className="text-[11px] uppercase tracking-[0.26em] text-[#FDFBF7]/70 mt-1">
                  {site.region}
                </div>
              </div>
            </div>

            <h3 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-10 leading-[1.05] tracking-tight">
              {site.brand}.
              <span className="block italic text-[#E6EAE3]/90">
                {site.tagline}
              </span>
            </h3>

            <a
              href={`mailto:${EMAIL}?subject=Care%20Inquiry`}
              data-testid="care-footer-email"
              className="mt-10 inline-flex items-center gap-3 text-lg md:text-xl border-b border-[#FDFBF7]/40 pb-1 hover:text-[#C86A51] hover:border-[#C86A51] transition-colors"
            >
              <Mail size={18} />
              {EMAIL}
              <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="lg:col-span-5 grid sm:grid-cols-2 gap-10">
            <div>
              <div className="text-xs uppercase tracking-[0.26em] text-[#FDFBF7]/60">
                Visit
              </div>
              <a
                href={mapsUrl}
                target="_blank"
                rel="noreferrer"
                className="block mt-5 font-serif-display text-xl leading-snug hover:text-[#C86A51] transition-colors"
              >
                {site.address.street}
                <br />
                {site.address.locality}
              </a>
              {site.phone && (
                <a
                  href={site.phoneHref}
                  className="mt-4 inline-block text-[#FDFBF7]/80 hover:text-[#C86A51] transition-colors"
                >
                  {site.phone}
                </a>
              )}
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.26em] text-[#FDFBF7]/60">
                The Heritage Family
              </div>
              <ul className="mt-5 space-y-3 text-[#FDFBF7]/90">
                <li>
                  <Link
                    to={site.sisterSite.to}
                    data-testid="footer-sister-site"
                    className="hover:text-[#C86A51] transition-colors inline-flex items-center gap-1"
                  >
                    {site.sisterSite.label}
                    <ArrowUpRight size={14} />
                  </Link>
                </li>
                <li>
                  <Link
                    to="/acquisitions"
                    className="hover:text-[#C86A51] transition-colors inline-flex items-center gap-1"
                  >
                    Heritage Homecare Holdings Group LLC
                    <ArrowUpRight size={14} />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#FDFBF7]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#FDFBF7]/60">
          <div>
            © {new Date().getFullYear()} Heritage Homecare Holdings Group LLC. All rights reserved.
          </div>
          <div className="font-serif-display italic text-[#FDFBF7]/70">
            Compassion · Dignity · Reliability
          </div>
        </div>
      </div>
    </footer>
  );
}
